import React from 'react'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

function FilterLabel({ columnName, isActive = false, onClearClick = null }) {
  return (
    <>
      <label
        className={`mr-2 fw-light ${
          isActive ? 'fw-normal text-primary' : 'text-muted'
        }`}
      >
        <small>{columnName}</small>
      </label>
      {isActive && (
        <div>
          {
            <Button
              variant="link"
              className="btn btn-sm m-0 p-0"
              onClick={onClearClick}
            >
              <FontAwesomeIcon icon={faTimes} className="me-1" />
              Clear
            </Button>
          }
        </div>
      )}
    </>
  )
}

export default FilterLabel
